/**
 * O corpo JSON de uma resposta 4xx/5xx de edge function.
 *
 * POR QUE ISTO PRECISA EXISTIR
 * ----------------------------
 * `supabase.functions.invoke` colapsa TODO não-2xx num `FunctionsHttpError`
 * cuja `message` é a constante "Edge Function returned a non-2xx status code",
 * e devolve `data: null`. Quem ramifica em `data.error` — o formato que a
 * função de fato responde — escreve um ramo que nunca executa: o `if (error)`
 * pega primeiro, sempre, e o operador recebe a constante no lugar da razão.
 *
 * O corpo continua lá, intacto: o supabase-js NÃO o consome, então dá para
 * lê-lo do `Response` cru pendurado em `error.context`. Este helper é esse
 * gesto, num lugar só — ele já morava duplicado em `writeFeatureFlag.ts` e em
 * `billing/ConfirmSendChargeDialog.tsx`, e a terceira cópia seria a que
 * esqueceria o `.clone()`.
 */
export async function readFunctionErrorBody<T = Record<string, unknown>>(
  error: unknown,
): Promise<T | null> {
  // `?.` porque o chamador pode passar o erro de um caminho sem resposta
  // (falha de rede, ou um `null` guardado numa variável): ler `.context` de
  // `null` estoura, e estourar aqui trocaria a mensagem ruim por uma tela
  // branca — pior que o defeito que este helper existe para corrigir.
  const context = (error as { context?: unknown } | null | undefined)?.context;
  if (!(context instanceof Response)) return null;
  try {
    // `.clone()` porque o corpo é um stream de leitura única: consumi-lo aqui
    // deixaria qualquer outro leitor (um log, um retry) com um stream vazio.
    return (await context.clone().json()) as T;
  } catch {
    // Corpo não-JSON (um 502 do gateway, por exemplo). Sem razão a extrair.
    return null;
  }
}
